export const SCREEN_NAME = {
    BOOKING_REVIEW_PAGE: "DO-ReviewBooking",
    PAYMENT_CART: "DO-PaymentCart",
    EVENT_TICKET_BOOKING: "DO-EventTicketBooking",
    DO_SCAN_SCREEN: "DO-ScanScreen",
    STEAL_STORE_CART: "DO-SS-cart",
    DINE_CASH_POOLING: "DO-DineCashPoolLP",
};

export const SOURCE = "book_table";
